import { useEffect, useMemo, useState } from "react";
import { Bar } from "react-chartjs-2";
import "chartjs-plugin-datalabels";
import Title from "../../../components/titleNew";
import "react-data-table-component-extensions/dist/index.css";
import {
  arrayBases,
  converterDataFormatoPadrao,
  converterLoja,
} from "../../../util/loja";

import TabelaNext from "../../../components/componentteste/TabelaNext";
import { TituloTabela } from "../../../components/TituloTabelaNew/TituloTabela";
import ButtonVoltar from "../../../components/ButtonVoltarNew";

import toast from "react-hot-toast";


import { PermissionsPage } from "../../../util/permissionsPage";
import { vendasService } from "../../../services/vendas";
import { useUserData } from "../../../hooks/useUserData";
import { Box, Paper, Stack, Typography } from "@mui/material";
import { LoadingTable } from "../../../components/Loading/LoadingTable";
import { MultiSelectFilterBases } from "../../../components/FilterLojaMetas/MultiSelectFilterBases";
import Select from "react-select";
import { FiltroPeriodo } from "../../../components/FiltroPeriodo/FiltroPeriodo";
import {
  calculateWidth,
  colourStyles,
  optionsChartBarVendas,
} from "./chartConfig";
import { ButtonFilter } from "../../../components/buttonFilter";
import { colunasBabyGestacao } from "./table";

function BabyMaisGestacao() {
  const { userData } = useUserData();
  const accessLevel = userData?.nivelAcesso;
  const acessBase = userData?.baseAcesso;
  const [isLoading, setIsLoading] = useState(true);
  const [periodoInputInicio, setPeriodoInputInicio] = useState("");
  const [periodoInputFim, setPeriodoInputFim] = useState("");
  const [lojasDisponiveis, setLojasDisponiveis] = useState([]);
  const [dadosGraficoAgrupado, setDadosGraficoAgrupado] = useState(false);
  const [filtrosLojasSelecionadas, setFiltrosLojasSelecionadas] = useState([]);
  const [codLojaAtiva, setCodLojaAtiva] = useState(false);
  const [dadosParaTabela, setDadosParaTabela] = useState([]);
  const [exibeTabela, setExibeTabela] = useState(false);
  const [filtradoPorLoja, setFiltradoPorLoja] = useState(false);
  const [nivelAtivoDoGraficoTotalVendas, setNivelAtivoDoGraficoTotalVendas] =
    useState(0);
  const [dadosDisponiveis, setDadosDisponiveis] = useState(true);
  const [nivelAcesso, setNivelAcesso] = useState([]);
  const [base, setBase] = useState(null);
  const [basesDisponiveis, setBasesDisponiveis] = useState([]);
  const [basesSelecionadas, setBasesSelecionadas] = useState([]);
  const [searchParams, setSearchParams] = useState(null);
  const uniqueKeyValue = useMemo(() => Date.now(), [dadosGraficoAgrupado]);
  const [dadosVendasAT, setDadosVendasAT] = useState([]);

  useEffect(() => {
    if (nivelAcesso.length === 0) {
      buscarNivelAcesso();
      setIsLoading(true);
      return;
    }
  }, [userData]);

  useMemo(() => {
    preencherDados("input");
  }, [searchParams]);

  useEffect(() => {
    preencherInputPeriodo();
  }, []);

  useEffect(() => {
    if (codLojaAtiva) {
      preencherDadosVendasPorLojaDrilldown(codLojaAtiva);
    }
  }, [codLojaAtiva]);

  useEffect(() => {
    if (filtradoPorLoja) {
      fVoltar();
    }
  }, [filtrosLojasSelecionadas, filtradoPorLoja]);

  const buscarNivelAcesso = () => {
    if (accessLevel) {
      setNivelAcesso(accessLevel);

      const bases = arrayBases(acessBase);
      setBasesDisponiveis(bases);
      if (bases?.length > 0) {
        const baseTemp = bases[0]?.value || bases[0]?.codBase;
        setBase([baseTemp]);
        setBasesSelecionadas([baseTemp]);
      } else {
        setBase(null);
        setBasesSelecionadas([]);
      }
    } else {
      setIsLoading(false);
    }
  };

  function preencherInputPeriodo() {
    var dataHoje = new Date();
    var [inicioAno, hoje] = converterDataFormatoPadrao(dataHoje);
    setPeriodoInputInicio(inicioAno);
    setPeriodoInputFim(hoje);
    iniciarFiltro({
      startPeriod: inicioAno,
      finalPeriod: hoje,
      stores: [],
      bases: [],
    });
  }

  function iniciarFiltro(defaultValue = null) {
    if (defaultValue) {
      return setSearchParams(defaultValue);
    }
    setSearchParams({
      startPeriod: periodoInputInicio,
      finalPeriod: periodoInputFim,
      stores: filtrosLojasSelecionadas,
      bases: basesSelecionadas,
    });
  }

  function processarDadosBabyPlus(
    vendasAT,
    chaveDeAgrupamento = "codClasse"
  ) {
    let groupedAT = {};

    if (chaveDeAgrupamento === "codClasse") {
      vendasAT.forEach((cls) => {
        let key = cls.codClasse;
        let vlrTotal = 0, totalPedidos = 0, vlrCusto = 0, vlrLucroBruto = 0, totalClientes = 0;
        let pLojas = cls.lojas || [];
        if (filtrosLojasSelecionadas.length > 0) {
          pLojas = pLojas.filter(l => filtrosLojasSelecionadas.includes(l.codLoja) || filtrosLojasSelecionadas.includes(String(l.codLoja)));
        }

        if (filtrosLojasSelecionadas.length === 0) {
          vlrTotal += Number(cls.VlrTotal || 0);
          totalPedidos += Number(cls.totalPedidos || 0);
          vlrCusto += Number(cls.VlrCusto || 0);
          vlrLucroBruto += Number(cls.VlrLucroBruto || 0);
          totalClientes += Number(cls.totalClientes || 0);
        } else {
          pLojas.forEach(loja => {
            vlrTotal += Number(loja.VlrTotal || 0);
            totalPedidos += Number(loja.totalPedidos || 0);
            vlrCusto += Number(loja.VlrCusto || 0);
            vlrLucroBruto += Number(loja.VlrLucroBruto || 0);
            totalClientes += Number(loja.totalClientes || 0);
          });
        }

        if (totalPedidos > 0 || vlrTotal > 0 || filtrosLojasSelecionadas.length === 0) {
          groupedAT[key] = { vlrTotal, totalPedidos, vlrCusto, vlrLucroBruto, totalClientes, loja: key };
        }
      });
    } else {
      vendasAT.forEach((loja) => {
        let key = loja.codLoja;
        if (filtrosLojasSelecionadas.length > 0 && !filtrosLojasSelecionadas.includes(key) && !filtrosLojasSelecionadas.includes(String(key))) {
          return;
        }
        groupedAT[key] = {
          vlrTotal: Number(loja.VlrTotal || 0),
          totalPedidos: Number(loja.totalPedidos || 0),
          vlrCusto: Number(loja.VlrCusto || 0),
          vlrLucroBruto: Number(loja.VlrLucroBruto || 0),
          totalClientes: Number(loja.totalClientes || 0),
          loja: key
        };
      });
    }

    let keys = new Set([...Object.keys(groupedAT)]);
    let sortedKeys;
    if (chaveDeAgrupamento === "codClasse") {
      sortedKeys = [...keys].sort((a, b) => {
        let numA = parseInt(a.replace(/\D/g, '')) || 0;
        let numB = parseInt(b.replace(/\D/g, '')) || 0;
        return numA - numB;
      });
    } else {
      sortedKeys = [...keys].sort((a, b) => Number(a) - Number(b));
    }

    let label = [];
    let dadosChartAT = [];
    let dadosChartClientesAT = [];
    let dadosTabela = [];

    let qtdAnoAtualResumo = 0,
      vlrAnoAtualResumo = 0,
      custoTotalAnoAtualResumo = 0,
      lucroBrutoTotalAnoAtualResumo = 0,
      totalClientesResumo = 0;

    let totalAT = Object.values(groupedAT).reduce(
      (acc, curr) => acc + Number(curr.totalPedidos),
      0
    );

    sortedKeys.forEach((k) => {
      let nomeCompleto =
        chaveDeAgrupamento === "codClasse" ? k : "Loja " + k;

      label.push(nomeCompleto);

      let rowAT = groupedAT[k] || {
        vlrTotal: 0, totalPedidos: 0, vlrCusto: 0, vlrLucroBruto: 0, totalClientes: 0,
      };

      dadosChartAT.push(rowAT.vlrTotal);
      dadosChartClientesAT.push(rowAT.totalClientes);

      qtdAnoAtualResumo += rowAT.totalPedidos;
      vlrAnoAtualResumo += rowAT.vlrTotal;
      custoTotalAnoAtualResumo += rowAT.vlrCusto;
      lucroBrutoTotalAnoAtualResumo += rowAT.vlrLucroBruto;
      totalClientesResumo += rowAT.totalClientes;

      let vlrMedioAnoAtual = rowAT.totalPedidos
        ? rowAT.vlrTotal / rowAT.totalPedidos
        : 0;

      let representatividadeAtual =
        rowAT.totalPedidos && totalAT
          ? (rowAT.totalPedidos / totalAT) * 100
          : 0;

      let lucro = rowAT.vlrTotal
        ? (rowAT.vlrLucroBruto / rowAT.vlrTotal) * 100
        : 0;

      dadosTabela.push({
        loja: k,
        qtdAnoAtual: rowAT.totalPedidos,
        vlrAnoAtual: rowAT.vlrTotal,
        totalClientes: rowAT.totalClientes,
        vlrMedioAnoAtual: vlrMedioAnoAtual,
        custoTotalAtual: rowAT.vlrCusto,
        lucroBrutoAtual: rowAT.vlrLucroBruto,
        lucro: lucro,
        representatividadeAtual: representatividadeAtual,
      });
    });

    let datalabelsStartAT = {
      anchor: "end", display: true, color: "#000", align: "end", rotation: 0,
      formatter: function (value) {
        return parseFloat(value).toLocaleString("pt-BR", {
          minimumFractionDigits: 0, maximumFractionDigits: 0,
        });
      },
    };

    let datalabelsClientesAT = {
      anchor: "end", display: true, color: "#000", align: "end", rotation: 0,
      formatter: function (value) {
        return parseFloat(value).toLocaleString("pt-BR", {
          minimumFractionDigits: 0, maximumFractionDigits: 0,
        });
      },
    };

    let dataSets = [
      {
        label: "Vendas no Período",
        data: dadosChartAT,
        backgroundColor: "rgba(91, 139, 252, 1)",
        datalabels: datalabelsStartAT,
        yAxisID: "y-axis-1"
      },
      {
        label: "Qtd. Clientes",
        data: dadosChartClientesAT,
        backgroundColor: "#FFDB8A",
        datalabels: datalabelsClientesAT,
        yAxisID: "y-axis-2"
      }
    ];

    const dataGrafico = { labels: label, datasets: dataSets };

    let vlrMedioAnoAtualResumo = vlrAnoAtualResumo / (qtdAnoAtualResumo || 1);
    let lucroPorcentagemAnoAtualResumo = vlrAnoAtualResumo ? (lucroBrutoTotalAnoAtualResumo / vlrAnoAtualResumo) * 100 : 0;

    dadosTabela.push({
      loja: "Resumo",
      qtdAnoAtual: qtdAnoAtualResumo,
      totalClientes: totalClientesResumo,
      vlrAnoAtual: vlrAnoAtualResumo,
      vlrMedioAnoAtual: vlrMedioAnoAtualResumo,
      custoTotalAtual: custoTotalAnoAtualResumo,
      lucroBrutoAtual: lucroBrutoTotalAnoAtualResumo,
      lucro: lucroPorcentagemAnoAtualResumo,
      representatividadeAtual: 100,
    });

    return { dataGrafico, dadosTabela };
  }

  async function preencherDados() {
    setFiltradoPorLoja(false);

    setExibeTabela(true);

    setIsLoading(true);
    window.scrollTo(0, 0);
    if (!base) {
      setIsLoading(false);
      setLojasDisponiveis([]);
      return;
    }
    const toastId = toast.loading("Esperando dados do RAD");

    try {
      const response = await vendasService.listaVendasBabyPlus({
        startPeriod: periodoInputInicio,
        finalPeriod: periodoInputFim,
        bases: base || [],
      });

      console.log(response);

      if (!response?.data) {
        toast.error("Não há conexão com o RAD", {
          duration: 7000,
          style: { borderRadius: "0.25rem", background: "#333", color: "#fff" },
        });
        setIsLoading(false);
        setDadosDisponiveis(false);
        return;
      }

      if (response?.status === 200) {
        toast.success("Dados recebidos", { id: toastId });

        let vendasAT = response.data.vendas || [];
        setDadosVendasAT(vendasAT);

        let allLojas = [];
        vendasAT.forEach(classe => {
          if (classe.lojas) {
            classe.lojas.forEach(loja => {
              allLojas.push(loja.codLoja);
            });
          }
        });
        let auxLojasSelecionadas = [...new Set(allLojas)].sort((a, b) => Number(a) - Number(b));
        setLojasDisponiveis(auxLojasSelecionadas);

        const { dataGrafico, dadosTabela } = processarDadosBabyPlus(
          vendasAT,
          "codClasse"
        );

        setDadosGraficoAgrupado(dataGrafico);
        setDadosParaTabela(dadosTabela);
        setNivelAtivoDoGraficoTotalVendas(0);

        setDadosDisponiveis(true);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const filtrarBases = (value) => {
    console.log(value); 
    let basesSelecionadasTemp = value;
    setBasesSelecionadas(basesSelecionadasTemp);
    setBase(basesSelecionadasTemp);
  };

  function preencherDadosVendasPorLojaDrilldown(codLoja) {
    let filterFn = (x) => String(x.codClasse) === String(codLoja);
    let classeEncontrada = dadosVendasAT.find(filterFn);

    let vendasAT = classeEncontrada && classeEncontrada.lojas ? classeEncontrada.lojas : [];

    const { dataGrafico, dadosTabela } = processarDadosBabyPlus(vendasAT, "codLoja");

    if (dataGrafico.datasets && dataGrafico.datasets.length > 0) {
      dataGrafico.datasets[0].label = `Vendas no Período - Nível ${codLoja}`;
    }

    setDadosGraficoAgrupado(dataGrafico);
    setDadosParaTabela(dadosTabela);
  }

  function fVoltar() {
    setCodLojaAtiva(false);
    const { dataGrafico, dadosTabela } = processarDadosBabyPlus(
      dadosVendasAT,
      "codClasse"
    );
    setDadosGraficoAgrupado(dataGrafico);
    setDadosParaTabela(dadosTabela);
    setNivelAtivoDoGraficoTotalVendas(0);
  }

  const iniciarFiltroPorLoja = (lojas) => {
    const lojasSelecionadas = lojas.map((item) => item.value);
    setFiltradoPorLoja(true);
    setFiltrosLojasSelecionadas(lojasSelecionadas);
  };

  const getElementAtEvent = (element) => {
    if (nivelAtivoDoGraficoTotalVendas > 0) return;
    if (!element.length) return;
    const { _index: index, _xScale: eixoX } = element[0];
    var nomeLoja = eixoX.ticks[index];
    let codLoja = nomeLoja.replace("Nível ", "");
    if (!codLoja) return;
    setCodLojaAtiva(codLoja);
    setNivelAtivoDoGraficoTotalVendas(1);
    preencherDadosVendasPorLojaDrilldown(codLoja);
  };

  return PermissionsPage("babyMaisGestacao") && (
    <>
      <Box ml={2}>
        <Title title="Vendas Baby+ Gestação" />
      </Box>

      <Stack gap={2} direction={"row"} mx={2}>
        <Box component={Paper} variant="outlined" px={1} pb={1}>
          <FiltroPeriodo
            periodoInputInicioAux={periodoInputInicio}
            periodoInputFimAux={periodoInputFim}
            setPeriodoInputInicioAux={setPeriodoInputInicio}
            setPeriodoInputFimAux={setPeriodoInputFim}
            esconderAte={true}
            titulo="Atualização da gestação"
          />
        </Box>

        <Box width={"100%"}>
          <Box pb={1}>
            <MultiSelectFilterBases
              basesDisponiveis={basesDisponiveis}
              basesSelecionadas={basesSelecionadas}
              onChange={filtrarBases}
              disabled={isLoading}
            />
            <Typography variant="caption" component={"span"}>
              *Atenção: Quando nenhuma base estiver selecionada, todas as
              bases serão retornadas.*
            </Typography>
          </Box>

          <Box pb={1}>
            <Typography
              textAlign={"initial"}
              fontWeight={"bold"}
              component={"span"}
            >
              Lojas
            </Typography>
            <Select
              options={lojasDisponiveis.map((lojas) => ({
                label: converterLoja(lojas),
                value: lojas,
              }))}
              isMulti
              onChange={iniciarFiltroPorLoja}
              placeholder="Selecione uma loja"
              styles={colourStyles}
              isDisabled={isLoading}
            />
            <Typography variant="caption" component={"span"}>
              *Atenção: Quando nenhuma loja estiver selecionada, todas as
              lojas serão retornadas.*
            </Typography>
          </Box>
          <Box>
            <ButtonFilter
              type="button"
              onClick={() => iniciarFiltro()}
              disabled={isLoading}
            >
              Filtrar
            </ButtonFilter>
          </Box>
        </Box>
      </Stack>

      {isLoading ? (
        <Box
          width={"100%"}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          height={"90vh"}
        >
          <LoadingTable isLoading={isLoading} />
        </Box>
      ) : (
        <>
          {dadosDisponiveis && dadosGraficoAgrupado && (
            <>
              <Box mx={2} component={Paper} variant="outlined" p={2} m={2}>
                <Box sx={{ overflowX: "scroll" }}>
                  <Bar
                    key={"grafico_vendas_" + uniqueKeyValue}
                    height={526}
                    width={calculateWidth(dadosGraficoAgrupado)}
                    data={dadosGraficoAgrupado}
                    options={{
                      ...optionsChartBarVendas,
                      title: {
                        ...optionsChartBarVendas.title,
                        text: codLojaAtiva ? `Vendas e Clientes - Nível ${codLojaAtiva}` : "Total de Vendas e Qtd. de Clientes"
                      }
                    }}
                    getElementAtEvent={getElementAtEvent}
                  />
                </Box>
                <ButtonVoltar fVoltar={fVoltar} />
              </Box>
            </>
          )}

          {dadosDisponiveis && exibeTabela && (
            <Box m={2} variant="outlined" style={{ overflow: "auto" }}>
              <TituloTabela>Vendas Por Loja</TituloTabela>
              <TabelaNext
                dadosParaTabela={dadosParaTabela}
                colunas={colunasBabyGestacao(codLojaAtiva)}
              />
            </Box>
          )}
        </>
      )}
    </>
  )
}

export default BabyMaisGestacao;
